<template>
	<div class="settlement-edc-card">
		<div
			class="m-d-12 card-list-settlement"
			v-for="(data, idx) in listSettlementEdc"
			:key="`${idx}-${data.idsettlement}`"
		>
			<SOSlotCard
				:id="`card-settlement-${data.idsettlement}`"
				:last-id="getLastId"
				:card-type="typeCard"
				@loadMore="doLoadMore"
				@toogleCard="toogleCard"
			>
				<template v-slot:card_body>
					<div @click="gotoDetail(data.idsettlement, data.idedc)">
						<div class="f-c-midgrey f-regular m-d-4" v-if="isNeedConfirm(data)">
							<div class="notice f-12">Menunggu konfirmasi</div>
						</div>
						<div class="d-flex-between-center f-16 f-semi f-c-black m-d-4">
							<div class="m-d-0 f-c-black">{{ data.nominal | currency }}</div>
							<img src="../../../assets/icons/chevron_right_4.svg"/>
						</div>
						<div class="f-13 f-regular f-c-midgrey m-d-2">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none"
							     xmlns="http://www.w3.org/2000/svg">
								<path
									d="M3.55558 3.33333H12.4445C13.286 3.33333 14 4.04038 14 4.95238V5.80952H2.00002V4.95238C2.00002 4.04038 2.71405 3.33333 3.55558 3.33333ZM15.3334 4.95238C15.3334 3.33965 14.0575 2 12.4445 2H3.55558C1.94251 2 0.666687 3.33965 0.666687 4.95238V11.0476C0.666687 12.6603 1.94251 14 3.55558 14H12.4445C14.0575 14 15.3334 12.6603 15.3334 11.0476V4.95238ZM14 7.14286V11.0476C14 11.9596 13.286 12.6667 12.4445 12.6667H3.55558C2.71405 12.6667 2.00002 11.9596 2.00002 11.0476V7.14286H14ZM3.62965 10.2857C3.62965 9.91753 3.92813 9.61905 4.29632 9.61905H4.30372C4.67191 9.61905 4.97039 9.91753 4.97039 10.2857C4.97039 10.6539 4.67191 10.9524 4.30372 10.9524H4.29632C3.92813 10.9524 3.62965 10.6539 3.62965 10.2857ZM6.59261 10.2857C6.59261 9.91753 6.89109 9.61905 7.25928 9.61905H8.74076C9.10895 9.61905 9.40743 9.91753 9.40743 10.2857C9.40743 10.6539 9.10895 10.9524 8.74076 10.9524H7.25928C6.89109 10.9524 6.59261 10.6539 6.59261 10.2857Z"
									fill="#C8D0DD"/>
							</svg>
							<span class="m-l-8" v-if="search.key === ''">{{ data.nama_edc }}  •  {{ data.nama_outlet }}</span>
							<span class="m-l-8 f-c-black" v-else v-html="searchHighlight(data.nama_edc + '  •  ' + data.nama_outlet, search.key)">}</span>
						</div>
						<div class="f-13 f-regular f-c-midgrey">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none"
							     xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd"
								      d="M3.33335 2.6665C3.70154 2.6665 4.00002 2.96498 4.00002 3.33317V7.4165C4.00002 7.85853 4.17562 8.28245 4.48818 8.59502C4.80074 8.90758 5.22466 9.08317 5.66669 9.08317H11.0572L9.27862 7.30457C9.01827 7.04423 9.01827 6.62212 9.27862 6.36177C9.53896 6.10142 9.96107 6.10142 10.2214 6.36177L13.1381 9.27843C13.3984 9.53878 13.3984 9.96089 13.1381 10.2212L10.2214 13.1379C9.96107 13.3983 9.53896 13.3983 9.27862 13.1379C9.01827 12.8776 9.01827 12.4554 9.27862 12.1951L11.0572 10.4165H5.66669C4.87104 10.4165 4.10798 10.1004 3.54537 9.53782C2.98276 8.97521 2.66669 8.21215 2.66669 7.4165V3.33317C2.66669 2.96498 2.96516 2.6665 3.33335 2.6665Z"
								      fill="#C8D0DD"/>
							</svg>
							<span class="m-l-8" v-if="search.key === ''">Ke {{ data.nama_rekening }}</span>
							<span class="m-l-8 f-c-black" v-else
							      v-html="searchHighlight(data.nama_rekening, search.key)"></span>
						</div>
            <div class="f-13 f-regular f-c-midgrey">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M3.33335 2.6665C3.70154 2.6665 4.00002 2.96498 4.00002 3.33317V7.4165C4.00002 7.85853 4.17562 8.28245 4.48818 8.59502C4.80074 8.90758 5.22466 9.08317 5.66669 9.08317H11.0572L9.27862 7.30457C9.01827 7.04423 9.01827 6.62212 9.27862 6.36177C9.53896 6.10142 9.96107 6.10142 10.2214 6.36177L13.1381 9.27843C13.3984 9.53878 13.3984 9.96089 13.1381 10.2212L10.2214 13.1379C9.96107 13.3983 9.53896 13.3983 9.27862 13.1379C9.01827 12.8776 9.01827 12.4554 9.27862 12.1951L11.0572 10.4165H5.66669C4.87104 10.4165 4.10798 10.1004 3.54537 9.53782C2.98276 8.97521 2.66669 8.21215 2.66669 7.4165V3.33317C2.66669 2.96498 2.96516 2.6665 3.33335 2.6665Z"
                      fill="#C8D0DD"/>
              </svg>
              <span class="m-l-8" v-if="search.key === ''">ID settlement {{ data.idsettlement }}</span>
              <span class="m-l-8 f-c-black" v-else
                    v-html="searchHighlight(data.idsettlement, search.key)"></span>
            </div>
					</div>
				</template>
				<template v-slot:card_footer>
					<div class="footer" :class="{ needConfirm: isNeedConfirm(data) }">
						<div
							class="m-d-0 f-12 f-regular f-c-black d-grid-12"
							style="padding: 4px 18px; align-items: center;"
						>
							<label class="m-d-0 grid-cspan-1" style="width:fit-content"
							       :class="{'f-c-black': isNeedConfirm, 'f-c-midgrey': !isNeedConfirm}">
								Oleh
							</label>
							<label class="m-d-0 grid-cspan-4 f-cont nama-kasir"
							       :class="{'f-c-black f-bold': isNeedConfirm, 'f-c-midgrey': !isNeedConfirm}">
								{{ getNamaKaryawan(data) }}
							</label>
							<label class="m-d-0 grid-cspan-4 f-cont f-c-midgrey"> ({{ data.tanggal_settlement_formated }})</label>
							<label
								class="m-d-0 grid-cspan-3 j-self-end statusBagde"
								:class="{
                                    approveBagde: getStatus(data) === 'Disetujui',
                                    declineBagde: getStatus(data) === 'Ditolak',
                                }"
							>
								{{ getStatus(data) }}
							</label>
						</div>
					</div>
				</template>
			</SOSlotCard>
		</div>
	</div>
</template>
<script>
import {mapGetters, mapActions} from "vuex";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";

import {moduleName} from "../store/state";

export default {
	name: "SOCardSettlementEdcGlobal",
	props: {
		typeCard: {
			type: String,
			default: "shadow",
		},
		search: {
			type: Object,
		},
	},
	components: {
		SOSlotCard,
	},
	computed: {
		...mapGetters(moduleName, {
			response: "response",
			isFetching: "isFetching",
			isLoadMore: "isLoadMore",
			pagination: "pagination",
			endItemOfPage: "endItemOfPage",

			listSettlementEdc: "listSettlementEdc",
			countData: "countData",
		}),
		getLastId() {
			return this.endItemOfPage.idsettlement ? `card-settlement-${this.endItemOfPage.idsettlement}` : "";
		},
		getNamaKaryawan() {
			return (data) => {
				return !data.nama_karyawan ? "Owner" : data.nama_karyawan;
			};
		},
		isNeedConfirm() {
			return (data) => {
				return data.status === 0
			};
		},
		getStatus() {
			return (data) => {
				if (data.status === 1) {
					return "Disetujui"
				}
				if (data.status === 2) {
					return "Ditolak"
				}
			};
		},
	},
	methods: {
		...mapActions({
			setLoadMore: `${moduleName}/setLoadMore`,
			getListSettlementEdc: `${moduleName}/getListSettlementEdc`,
			toogleDisplayCard: `${moduleName}/toogleDisplayCard`,
		}),
		async doLoadMore() {
			if (this.countData > this.pagination.length) {
				if (!this.isFetching) {
					await this.setLoadMore(true);
					await this.getListSettlementEdc(this.search);
					await this.setLoadMore(false);
				}
			}
		},
		toogleCard(data) {
			this.toogleDisplayCard(data);
		},
		gotoDetail(id, idedc) {
			this.smartTrackingClick("detail_settlement_mesin_edc");

			this.$router.push({name: "mesin.edc.detail_setoran_global", params: {id_settlement: id, id_mesin: idedc}});
		},
	},
};
</script>

<style scoped>
.notice {
	background: #ededed;
	width: fit-content;
	padding: 0 4px;
	border-radius: 3px;
	font-size: 12px !important;
}

.nama-kasir {
	max-width: 50%;
	margin-bottom: 0px;
	margin: 0px 4px;
}

.footer {
	margin: -8px -18px -10px;
	border-bottom-right-radius: 5px;
	border-bottom-left-radius: 5px;
}

.needConfirm {
	background: linear-gradient(90deg, #fff8e1 0%, #ffffff 100%);
}

.statusBagde {
	justify-self: end;
	padding: 2px 8px;
	border-radius: 25px;
}

.approveBagde {
	background-color: #e8fcee;
	color: #40964C;
}

.declineBagde {
	background-color: #fff1f1;
	color: #964040;
}
</style>
